var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { Link } from 'react-router-dom';

import { Translate } from "../../../../../I18N";
import { Button, Pill } from "../../../../Components/UI";


const LabelHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Name");
const TypeHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Type");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Action");

const RenderButton = ({ cell }) => /*#__PURE__*/
_jsx(Link, { to: `edit/${cell.row.original.id}` }, void 0, /*#__PURE__*/
_jsx(Button, { styling: "light", className: "leading-4" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Translate")
)
);


const ContextPill = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, cell.renderValue())
)
);


export { RenderButton, ContextPill, LabelHeader, TypeHeader, ActionHeader };